import { useState } from "react";
import { ReactComponent as ChevronRight } from "../../Assets/angle-right-solid.svg";
import Communicator from "../../Helper/Communicator";
import { isPassToAgentItem, startPassToAgent } from "../../Helper/PassToAgent";
import { ConfigMenuItem } from "../../Stores/Config";
import { useRouterStore } from "../../Stores/Router";
import { useTicketStore } from "../../Stores/Ticket";
import { activateOnKey } from "../../Helper/a11y";
import "./WidgetMenuTag.scss";

const WidgetMenuTag = ({
  menuItem,
  index,
  variant,
}: {
  menuItem: ConfigMenuItem;
  index: number;
  variant?: string;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const routerStore = useRouterStore();
  const ticketStore = useTicketStore();

  const handleClick = () => {
    if (isLoading) {
      return;
    }

    // Make component loading
    setIsLoading(true);

    Communicator.trackWidgetEvent("gleap-home-menu-clicked", {
      title: menuItem.title,
      actionType: menuItem.actionType,
    });

    if (menuItem.actionType === "CUSTOM_ACTION") {
      if (menuItem.actionBody) {
        Communicator.runCustomAction(menuItem.actionBody);
        if (menuItem?.closeWidgetAfterAction ?? true) {
          Communicator.closeWidget();
        }
      }
    } else if (menuItem.actionType === "REDIRECT_URL") {
      if (menuItem.actionBody) {
        Communicator.openURL(
          menuItem.actionBody,
          menuItem.actionOpenInNewTab ? true : false,
        );
      }
    } else if (isPassToAgentItem(menuItem)) {
      startPassToAgent(menuItem);
    } else if (menuItem.actionType === "BOT") {
      ticketStore.createNewConversation({
        botId: menuItem.botId,
        isManualStart: true,
      });
    } else {
      routerStore.pushPage("flow", {
        flowId: menuItem.actionType,
      });
    }
    setIsLoading(false);
  };

  if (variant === "list") {
    return <button
      id={`menu-tag-${index}`}
      type="button"
      className="widget-menu-tag widget-menu-tag--list"
      onClick={handleClick}
      disabled={isLoading}
    >
      <span className="widget-menu-tag-label">{menuItem.title}</span>
      <ChevronRight className="widget-menu-tag-chevron" aria-hidden="true" focusable="false" />
    </button>;
  }

  return (
    <div
      id={`menu-tag-${index}`}
      className={`widget-menu-tag ${
        variant ? `widget-menu-tag--${variant}` : ""
      }`}
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={activateOnKey(handleClick)}
    >
      {menuItem.icon && (
        <img
          src={menuItem.icon}
          alt={menuItem.title}
          className="widget-menu-tag-icon"
        />
      )}
      {menuItem.title}
    </div>
  );
};

export default WidgetMenuTag;
